import { z } from 'zod';
// ── crearVacacionesApplicationSchema — POST /vacaciones-applications (Prompt AF(RH), AF-3(RH), BB-2(RH)) ──
// Cualquier usuario autenticado crea su propia solicitud. aprobadorId NO viaja
// en el payload — se resuelve en el servicio desde usuarios.aprobador_permisos_id
// del solicitante (snapshot fijo al crear). dias_habiles_solicitados tampoco
// viaja — se calcula en el servicio vía calcularDiasHabiles().
//
// AF-3(RH): usuario_id/aprobar_inmediato son opcionales y solo tienen efecto
// para actores RH/root (validado en el servicio, no aquí — Zod no conoce el
// rol del actor). usuario_id ausente = solicita para sí mismo (comportamiento
// preexistente, sin cambios). aprobar_inmediato solo aplica junto con un
// usuario_id distinto del propio — RH/root creando Y aprobando en el mismo
// acto a nombre de otro colaborador.
//
// BB-2(RH): reemplaza el viejo `tipo_ausencia_id` (tramo específico) por
// `categoria_visible` (el string agrupador del selector — "Vacaciones",
// "Enfermedad", etc.) — el servicio resuelve contra TODOS los tramos que
// compartan esa categoría visible, no un único id.
export const crearVacacionesApplicationSchema = z
    .object({
    categoria_visible: z.string().min(1).max(100),
    fecha_inicio_solicitada: z.string().date(),
    fecha_fin_solicitada: z.string().date(),
    motivo: z.string().max(2000).optional(),
    usuario_id: z.string().uuid().optional(),
    aprobar_inmediato: z.boolean().optional(),
})
    .refine(d => d.fecha_inicio_solicitada <= d.fecha_fin_solicitada, {
    message: 'fecha_inicio_solicitada no puede ser posterior a fecha_fin_solicitada',
    path: ['fecha_fin_solicitada'],
});
// ── aprobarVacacionesApplicationSchema — PATCH /vacaciones-applications/:id/aprobar ──
// Fechas opcionales: si el aprobador no las toca, el servicio usa las
// solicitadas originalmente. Si vienen ambas, deben ser un rango válido.
export const aprobarVacacionesApplicationSchema = z
    .object({
    fecha_inicio_aprobada: z.string().date().optional(),
    fecha_fin_aprobada: z.string().date().optional(),
})
    .refine(d => !d.fecha_inicio_aprobada || !d.fecha_fin_aprobada || d.fecha_inicio_aprobada <= d.fecha_fin_aprobada, {
    message: 'fecha_inicio_aprobada no puede ser posterior a fecha_fin_aprobada',
    path: ['fecha_fin_aprobada'],
})
    .refine(d => (d.fecha_inicio_aprobada === undefined) === (d.fecha_fin_aprobada === undefined), {
    message: 'fecha_inicio_aprobada y fecha_fin_aprobada deben venir juntas o ninguna',
    path: ['fecha_fin_aprobada'],
});
// ── rechazarVacacionesApplicationSchema — PATCH /vacaciones-applications/:id/rechazar ──
export const rechazarVacacionesApplicationSchema = z.object({
    comentario_aprobador: z.string().max(2000).optional(),
});
//# sourceMappingURL=vacaciones-applications.js.map